var map = {
	"./hero/1.png": 9401,
	"./hero/2.png": 958,
	"./hero/3.png": 1254,
	"./hero/4.png": 6774,
	"./hero/5.png": 7662,
	"./hero/6.png": 2567,
	"./hero/dear-roy-profile.png": 3063,
	"./hero/orange-svg.svg": 4,
	"./hero/purple-svg-2.svg": 8681,
	"./hero/purple-svg.svg": 4257,
	"./hero/yellow-big-svg.svg": 1833,
	"./profile-1.png": 3977,
	"./profile-2.png": 9754,
	"./testimonials/testimonials-1.jpg": 3454,
	"./testimonials/testimonials-2.jpg": 8623,
	"./testimonials/testimonials-3.jpg": 5787,
	"./testimonials/testimonials-4.jpg": 6229,
	"./testimonials/testimonials-5.jpg": 8789
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6303;